export enum OutputFrequency {
  annually = 'annually',
  daily = 'daily',
  monthly = 'monthly'
}

export enum InputMethod {
  EXCEL = 'excel',
  FORMULA = 'formula',
  FREESTYLE = 'freestyle',
  REPEATING = 'repeating',
  UNIT = 'unit'
}

export enum QuickActionsType {
  setSelectedTo = 'set-selected-to',
  increaseByPercentage = 'increase-by-percentage',
  decreaseByPercentage = 'decrease-by-percentage',
  increaseByAmount = 'increase-by-amount',
  decreaseByAmount = 'decrease-by-amount',
  splitBetweenSelected = 'split-between-selected'
}

export enum YesNo {
  yes = 'yes',
  no = 'no'
}

export const MAX_DECIMALS = 6;
